var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuList = void 0;
var MenuList_1 = __importDefault(require("./MenuList"));
exports.MenuList = MenuList_1.default;
exports.default = MenuList_1.default;
//# sourceMappingURL=index.js.map